import { render } from "./SelectRichItems.vue?vue&type=template&id=18aead35"
import script from "./SelectRichItems.vue?vue&type=script&lang=js"
export * from "./SelectRichItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__